const e = {
  Analytics: [
    {
      value: "analytics",
      label: "Organization analytics",
      description: "Manage analytics for all organization users"
    }
  ],
  Contacts: [
    {
      value: "contact.ban",
      label: "Ban customer from Chat / Messenger conversation",
      description: "Ban contacts"
    },
    {
      value: "contact.contact_point",
      label: "Modify contact points",
      description: "Make changes to contact's contact points (email, phone number, etc.)"
    },
    {
      value: "contact.custom_attribute",
      label: "Custom contact attributes",
      description: "Manage values of custom contact attributes"
    },
    {
      value: "contact.merge",
      label: "Merge contacts",
      description: "Merge contacts"
    }
  ],
  Conversation: [
    {
      value: "conversation.call",
      label: "Listen in on conversations",
      description: "Listen in ongoing phone calls"
    },
    {
      value: "conversation.custom_attribute",
      label: "Conversations custom attributes",
      description: "Manage values of conversation custom attributes"
    },
    {
      value: "conversation.export",
      label: "Export conversations",
      description: "Export conversations"
    },
    {
      value: "conversation.import",
      label: "Scheduled conversations",
      description: "Import conversations"
    },
    {
      value: "conversation.integration",
      label: "Custom cards",
      description: "Access custom cards and integrations for a conversation"
    },
    {
      value: "conversation.log",
      label: "Activity log",
      description: "View conversation activity log"
    },
    {
      value: "conversation.call_recording",
      label: "Listen in on call recordings",
      description: "Access and listen in on recordings of phone call conversation"
    },
    {
      value: "conversation.reply",
      label: "Respond to a conversation",
      description: "Reply on conversations (includes assignment through claim, transfer)"
    },
    {
      value: "conversation.satisfaction",
      label: "Manage customer satisfaction (CSAT)",
      description: "View/Cancel user CSAT submissions"
    },
    {
      value: "conversation.tag",
      label: "Tagging",
      description: "Manage conversation tags"
    }
  ],
  Knowledge: [
    {
      value: "knowledge.collections:r",
      label: "View knowledge collections",
      description: "View knowledge collections",
      featureFlags: ["knowledge-access"]
    },
    {
      value: "knowledge.collections:w",
      label: "Modify knowledge collections",
      description: "Modify knowledge collections",
      requiredScopes: ["knowledge.collections:r"],
      featureFlags: ["knowledge-access"]
    },
    {
      value: "knowledge.content:r",
      label: "View knowledge content",
      description: "View knowledge content",
      featureFlags: ["knowledge-access"]
    },
    {
      value: "knowledge.content:w",
      label: "Modify knowledge content",
      description: "Modify knowledge content",
      requiredScopes: ["knowledge.content:r"],
      featureFlags: ["knowledge-access"]
    }
  ],
  Organization: [
    {
      value: "organization.access",
      label: "Access roles",
      description: "Manage authorization settings"
    },
    {
      value: "organization.billing",
      label: "Billing",
      description: "Manage billing settings"
    },
    {
      value: "organization.info",
      label: "Organization info",
      description: "Manage organization information"
    },
    {
      value: "organization.invite",
      label: "Invite agents",
      description: "Invite organization members"
    },
    {
      value: "organization.member",
      label: "Agents",
      description: "Manage users"
    },
    {
      value: "organization.team",
      label: "Manage teams",
      description: "Manage teams"
    },
    {
      value: "organization.workload",
      label: "Workloads",
      description: "Manage workload settings"
    }
  ],
  Settings: [
    {
      value: "settings.audio_file",
      label: "Audio files settings",
      description: "Manage audio files"
    },
    {
      value: "settings.business_hours",
      label: "Business hours settings",
      description: "Manage business hours"
    },
    {
      value: "settings.chatbot",
      label: "Chatbot settings",
      description: "Manage chatbot settings",
      featureFlags: [
        "mim-chatbot",
        "ada-chat-channel",
        "digitalgenius-chat-channel",
        "kindly-chat-channel"
      ],
      featureFlagsStrategy: "any",
      requiredScopes: ["settings.integration.channel.edit"]
    },
    {
      value: "settings.contact_ban",
      label: "Banned users settings",
      description: "Manage contact bans"
    },
    {
      value: "settings.copilot",
      label: "Copilot settings",
      description: "Manage copilot settings"
    },
    {
      value: "settings.custom_attribute",
      label: "Manage custom attribute",
      description: "Manage custom attribute and forms definitions"
    },
    {
      value: "settings.custom_away_status",
      label: "Away status settings",
      description: "Manage away statuses",
      featureFlags: ["custom-away-status"]
    },
    {
      value: "settings.flow:r",
      label: "View flows",
      description: "View flows and automations settings"
    },
    {
      value: "settings.flow:w",
      label: "Manage flows",
      description: "Modify flows and automations settings",
      requiredScopes: ["settings.flow:r"]
    },
    {
      value: "settings.intent_detection",
      label: "Intent detection settings",
      description: "Manage intent detection settings",
      featureFlags: ["intent-detection"]
    },
    {
      value: "settings.helpcenter:r",
      label: "View help center settings",
      description: "View knowledge help center settings",
      featureFlags: ["knowledge-access"]
    },
    {
      value: "settings.helpcenter:w",
      label: "Modify help center settings",
      description: "Modify knowledge help center settings",
      requiredScopes: ["settings.helpcenter:r"],
      featureFlags: ["knowledge-access"]
    },
    {
      value: "settings.integration.api",
      label: "Manage API integrations",
      description: "Manage API integrations"
    },
    {
      value: "settings.integration.channel.edit",
      label: "Edit channel integration properties",
      description: "Edit channel integration properties",
      requiredScopes: ["settings.flow:r"]
    },
    {
      value: "settings.integration.channel.setup",
      label: "Setup and remove channel integrations",
      description: "Setup and remove channel integrations",
      requiredScopes: [
        "settings.integration.channel.edit",
        "settings.flow:w",
        "settings.flow:r"
      ]
    },
    {
      value: "settings.knowledge:r",
      label: "View knowledge settings",
      description: "View knowledge settings"
    },
    {
      value: "settings.knowledge:w",
      label: "Modify knowledge settings",
      description: "Modify knowledge settings",
      requiredScopes: ["settings.knowledge:r"]
    },
    {
      value: "settings.queue:r",
      label: "View queues",
      description: "View queue settings"
    },
    {
      value: "settings.queue:w",
      label: "Create and archive queues",
      description: "Create and archive queues",
      requiredScopes: ["settings.queue:r"]
    },
    {
      value: "settings.queue.offering",
      label: "Manage queue settings",
      description: "Manage offering and alerts for queues"
    },
    {
      value: "settings.queue.members",
      label: "Manage queue members",
      description: "Manage queues members and teams"
    },
    {
      value: "settings.satisfaction",
      label: "Satisfaction (CSAT) settings",
      description: "Manage Satisfaction (CSAT) settings"
    },
    {
      value: "settings.tag",
      label: "Manage tags",
      description: "Manage organization tags"
    },
    {
      value: "settings.template",
      label: "Manage templates",
      description: "Manage message templates"
    },
    {
      value: "settings.writing_style",
      label: "Writing style guide",
      description: "Manage writings styles"
    }
  ]
}, t = e;
export {
  t as authorizationScopes
};
//# sourceMappingURL=index.js.map
